import script from "./searchInputEvent.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchInputEvent.vue?vue&type=script&setup=true&lang=ts"

import "./searchInputEvent.vue?vue&type=style&index=0&id=ba3426ce&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba3426ce"]])

export default __exports__